import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { EnterCode } from 'apps/art-stream-voucher/components/EnterCode';
import { configureStore } from 'store/configureStore';

const store = configureStore();

export const ArtStreamVoucher: React.FC<{}> = () => (
  <Provider store={store}>
    <Router>
      <Switch>
        <Route exact path={'/voucher'} component={EnterCode} />
      </Switch>
    </Router>
  </Provider>
);
